import { supportedDrmsResolved } from '@setplex/player'
import { isbot } from 'isbot'
import { UAParser } from 'ua-parser-js'
import { DeviceType } from '~/shared/constants'

export const app = {
  name: 'UVOtv',
  domain: location.host,
} as const

//
// get information from user-agent string
//

export const ua: UAParser.IResult = UAParser(navigator.userAgent)
export const isBot = isbot(navigator.userAgent)

export const os = {
  name: ua.os.name,
  version: ua.os.version,
} as const

// TODO: should use feature detection, in case user agent string is spuffed
export const browser = {
  name: ua.browser.name,
  version: ua.browser.version,
} as const

/**
 * Uses only the UA string (ua-parser `device.type` is unreliable in browsers).
 * Also handles iPad in Safari «desktop site» mode (UA looks like Mac Safari, no "iPad" substring).
 */
export const getDeviceType = (): DeviceType => {
  const ua = navigator.userAgent

  if (/iPad/i.test(ua)) return DeviceType.Tablet
  if (/iPhone|iPod/i.test(ua)) return DeviceType.Phone

  if (/Android/i.test(ua)) {
    return /Mobile/i.test(ua) ? DeviceType.Phone : DeviceType.Tablet
  }

  if (/Silk|Kindle|PlayBook|Tablet/i.test(ua)) return DeviceType.Tablet

  if (
    /Mobi|BlackBerry|IEMobile|Opera Mini|webOS|Windows Phone|WPDesktop/i.test(
      ua
    )
  ) {
    return DeviceType.MobileTabletFallback
  }

  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return DeviceType.Tablet
  }

  return DeviceType.Desktop
}

export const device = {
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
  // > If the device is large enough that it's not marked with Mobi,
  // > you should serve your desktop site (which, as a best practice,
  // > should support touch input anyway, as more desktop machines are appearing with touchscreens).
  type: getDeviceType(),
} as const

// TODO: could check https://github.com/fingerprintjs/fingerprintjs repo for more references

//
// EME support
//

export const drms: string[] = []

// wait until player detects supported DRM systems
supportedDrmsResolved.then((resolved: Map<string, string[]>) => {
  const types = [...resolved.keys()].map((type) => type.toUpperCase())
  Array.prototype.push.apply(drms, types)
})
